module.exports = __webpack_public_path__ + "static/media/offline-training.507e90d4.svg";